export const loadScriptsInSequence = (
  scripts: HTMLScriptElement[],
  container: HTMLElement,
  index: number = scripts.length - 1
): void => {
  if (!scripts || !scripts.length) return;
  if (index === 0) container.appendChild(scripts[index]);
  else {
    const scriptsCopy = [...scripts];
    scriptsCopy[index - 1].onload = () => {
      container.appendChild(scripts[index]);
    };
    loadScriptsInSequence(scriptsCopy, container, index - 1);
  }
};

export default {loadScriptsInSequence};
